var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SvgIcon',{staticClass:"status",class:("status--" + _vm.status),attrs:{"name":_vm.statusIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }